module.exports = __webpack_public_path__ + "img/23ca59c.jpg";